import { Component, ViewChild, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { CosyCommunicationControllerService } from '../service/controller/cosy-communication-controller.service';
import { CosyLoginComponent } from '../cosy-login/cosy-login.component';
//import * as _ from 'lodash';
import assignIn  from 'lodash-es/assignIn';

import { UXControllerService } from '../service/controller/ux-controller.service';
//import { Subject, Subscription } from 'rxjs';

@Component({
  selector: 'app-cosy-server',
  templateUrl: './cosy-server.component.html',
  styleUrls: ['./cosy-server.component.css']

})
export class CosyServerComponent implements OnInit {
  @ViewChild(CosyLoginComponent) child: CosyLoginComponent;
  appList: any[] = [];
  appNoDisplayList: string[] = ['cosyallconsumer', 'startup', 'cosybackendapp', 'cosyframework', 'cosyframeworkfactory'];
  appNoDisplayListAdmin: string[] = ['cosyallconsumer', 'startup'];
  public href: string = "";
  private parameters;
  private cosyToken: string = null;
  private appServerOwner: string;
  private cssUrl: string;
  public isDoubleClicked: boolean = false;
  public clickCounts: number = 1;

  constructor(
    private activatedRoute: ActivatedRoute,
    private uxControllerService: UXControllerService,
    private cosyCommunicationControllerService: CosyCommunicationControllerService,
    private router: Router
  ) { }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      if (params != null && params['cosyToken']) {
        let cosyToken = params['cosyToken'];
        this.cosyTokenChance(cosyToken);
      }
    });
    // Entfernen der app-CSS-Dateien bei historyback
    let removelink = document.getElementById('app');
    if (removelink != null) document.head.removeChild(removelink);
    // Laden der Custom und Default CSS-Dateien
    let serverlink: HTMLElement = document.getElementById('server');
    if (serverlink == null) {
      let link: HTMLLinkElement = document.createElement("link");
      link.setAttribute('rel', 'stylesheet');
      link.setAttribute('content-type', 'text/css');
      link.setAttribute('id', 'server');
      this.cosyCommunicationControllerService.getRuntimeKey(this.uxControllerService.sessionID, "AppServerOwner").subscribe(
        key => {
          this.appServerOwner = key["value"];
          this.uxControllerService.AppServerOwner = this.appServerOwner;
          this.cssUrl = "/assets/consumer/" + this.appServerOwner.toLocaleLowerCase() + "/css/server.css";
          link.setAttribute('href', this.cssUrl);
          link.onerror = function (evt) {
            link.setAttribute('href', '/assets/default/css/server.css');
            document.head.appendChild(link);
          };
          document.head.appendChild(link);
        },
        error => {
          this.appServerOwner = '';
          this.cssUrl = "/assets/default/css/server.css";
          link.setAttribute('href', this.cssUrl);
          document.head.appendChild(link);
        });
    }

    this.cosyTokenChance(this.uxControllerService.cosyToken);
  }

  chkMultiClicks() {
    this.clickCounts = this.clickCounts + 1;
  }

  cosyTokenChance(cosyToken: string) {
    this.cosyToken = cosyToken;
    let cssClass: string = 'card-img gray80';
    let appNoDisplayList = this.appNoDisplayList;
    this.cosyCommunicationControllerService.getAppList(cosyToken).subscribe(
      apps => {
        if (this.cosyToken != null) {
          cssClass = 'card-img';
          if (this.uxControllerService.ActivePrimaryGroup == '67faa3df-1743-4368-b905-58a433ce1693' || this.uxControllerService.ActivePrimaryGroup == 'f8e8e32a-fc49-417a-875a-aa463a256a9c') appNoDisplayList = this.appNoDisplayListAdmin; //Administrator oder CosyDeveloper
        }
        this.appList = [];
        let count = 0;
        let appListHelp: any[] = [];
        let ListHelp: any = apps['value'];
        ListHelp.filter(element => !appNoDisplayList.includes(element.DisplayName.replace(/Standard/gi, '').replace(/ /g, '').toLowerCase())).forEach(element => {
          let img: HTMLImageElement = document.createElement('img');
          element.DisplayName = element.DisplayName.replace(/ Standard/gi, '').replace(/Standard/gi, '')
          let pathAndName: string = element.DisplayName.replace(/ /g, '').toLowerCase();
          let imgurl = '/assets/apps/' + pathAndName + '/images/' + pathAndName + '.png';
          if (pathAndName == window.location.hostname || pathAndName == window.location.hostname.split('.')[0]) {
            this.uxControllerService.appName = element.DisplayName;
            this.parameters = { appName: element.DisplayName, appID: element.ID };
            this.router.navigate(['/login'], { queryParams: this.parameters });
          }
          img.setAttribute('src', imgurl);
          img.setAttribute('class', cssClass);
          img.setAttribute('id', element.ID);
          img.onerror = function (evt) {
            let cardImg: HTMLElement = document.getElementById(img.id);
            if (cardImg != null) cardImg.setAttribute('src', '/assets/images/dummy.png');
          };
          assignIn(element, { 'imgurl': img.src, 'class': img.className, 'imgID': img.id });
          if (count != 0 && count % 3 == 0) {

            this.appList.push(appListHelp);
            appListHelp = [];
          }
          appListHelp.push(element);
          count++;
        });
        this.appList.push(appListHelp);
      },
      error => console.error('ERROR: ', error),
    );
  }

  choiceApp(appName: string, appID: string, ID: string) {
    let sCOSYBackup: string = '3D705C9D-E3D4-43A4-AF92-2D1C58561321'//	COSYBackup
    let sCOSYappfactory: string = '5200D876-3469-4DAD-8E1D-75BE29CA892D'//	COSYappfactory Standardvariante
    let sCosyFrameworkFactory: string = 'A521A42C-C356-4E23-99B0-8AE55A246B56'//	CosyFrameworkFactory Standard
    let managedAppID: string = null;
    if(this.uxControllerService.currentBreadCrumbTitle == 'Home') this.uxControllerService.currentBreadCrumbTitle = '';
    if (this.clickCounts == 1) {
      if (appID == null || appID == '') appID = ID; //unterschied X_Mandator_Variant oder Variant
      this.cosyCommunicationControllerService.appID = appID;
      this.uxControllerService.appName = appName;
      if (this.cosyToken != null) {
        if (appID.toUpperCase() == sCOSYBackup.toUpperCase() || appID.toUpperCase() == sCOSYappfactory.toUpperCase() || appID.toUpperCase() == sCosyFrameworkFactory.toUpperCase()) {
          this.cosyCommunicationControllerService.getRuntimeKey(this.cosyToken, "DefaultVariantID").subscribe(
            key => {
              managedAppID = <string>key["value"];
              this.child.authorizeUser(appID, managedAppID);
            },
            error => console.error('ERROR: ', error),
          );
        }
        else this.child.authorizeUser(appID, managedAppID);
      }
      else {
        this.parameters = { appName: appName, appID: appID };
        this.router.navigate(['/login'], { queryParams: this.parameters });
      }
    } else { }

  }

  imageExists(url, callback) {
    let img = new Image();
    img.onload = function () { callback(true); };
    img.onerror = function () { callback(false); };
    img.src = url;
  }
  /* Aufruf für imageExists
  this.imageExists(imgurl, function (exists) {
    if (exists) _.assignIn(element, { 'imgurl': imgurl, 'class': cssClass });
    else _.assignIn(element, { 'imgurl': '/assets/images/dummy.png', 'class': cssClass });
  }); 
  */


}